import { ISurveyAnswerItem } from "../libs/interfaces/services";

/**
 * Verifica se uma resposta de questionário é válida (não vazia).
 * Checa answerInt, answerString, answerArray e answerDate.
 */
export function isValidAnswer(answer: ISurveyAnswerItem): boolean {
  // Verifica se answerInt é diferente de 0
  if (
    answer.answerInt !== 0 &&
    answer.answerInt !== null &&
    answer.answerInt !== undefined
  ) {
    return true;
  }

  // Verifica se answerString não está vazio
  if (answer.answerString && answer.answerString.trim() !== "") {
    return true;
  }

  // Verifica se answerArray não está vazio
  if (
    answer.answerArray &&
    answer.answerArray !== "" &&
    answer.answerArray !== "[]"
  ) {
    try {
      const parsed = JSON.parse(answer.answerArray);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return true;
      }
    } catch {
      if (answer.answerArray.trim() !== "") {
        return true;
      }
    }
  }

  // Verifica se answerDate não é null ou undefined
  if (
    answer.answerDate &&
    answer.answerDate !== null &&
    answer.answerDate !== undefined
  ) {
    return true;
  }

  return false;
}
